import React, { memo } from "react";

import { Dispatch, State } from "../StateManager/state";
import { JobState } from "../types";
import { JobActions } from "./JobActions";
import { LabelList as RawLabelList } from "./LabelList";

const LabelList = memo(RawLabelList);

type Props = Readonly<{
  activeLabel: State["currentLabel"];
  currentLabelGroup: State["currentLabelGroup"];
  zoningTaxonomyName: string;
  dispatch: Dispatch;
  jobState: JobState;
  onReset: () => void;
  onSave: () => void;
  onSubmit: () => void;
  pageModified: boolean;
  readonly: boolean;
  taxonomy: State["taxonomy"];
  state: State;
}>;

export const Menu = ({
  activeLabel,
  currentLabelGroup,
  zoningTaxonomyName,
  dispatch,
  jobState,
  onReset,
  onSave,
  onSubmit,
  pageModified,
  readonly,
  taxonomy,
  state,
}: Props) => {
  return (
    <div className="left-menu">
      <JobActions
        dispatch={dispatch}
        onReset={onReset}
        onSave={onSave}
        onSubmit={onSubmit}
        pageModified={pageModified}
        readonly={readonly}
        saving={jobState === JobState.Saving}
        submitting={jobState === JobState.Submitting}
        state={state}
      />
      <hr />
      <LabelList
        zoningTaxonomyName={zoningTaxonomyName}
        activeLabel={activeLabel}
        currentLabelGroup={currentLabelGroup}
        dispatch={dispatch}
        readonly={readonly}
        taxonomy={taxonomy}
      />
    </div>
  );
};
Menu.displayName = "Menu";
